var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightBrucke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34082 13.1279L1.34082 10.8574L14.876 10.8574C15.2959 10.8574 15.6523 10.7109 15.9453 10.418C16.2383 10.125 16.3848 9.76856 16.3848 9.34863C16.3848 8.93848 16.2432 8.5918 15.96 8.30859L12.1514 4.5L15.1543 4.5L22.6543 12L15.1543 19.5H12.1514L15.96 15.6768C16.2432 15.3936 16.3848 15.0469 16.3848 14.6367C16.3848 14.2168 16.2383 13.8604 15.9453 13.5674C15.6523 13.2744 15.2959 13.1279 14.876 13.1279L1.34082 13.1279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBrucke);
export default __webpack_public_path__ + "static/media/arrow-right-brucke.e2fdd83ddf798ee84ff4273d928725c2.svg";
export { ForwardRef as ReactComponent };